module.exports = __webpack_public_path__ + "img/eyes1.e9239e6f.svg";